import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';


type Make = {
    total: number,
    make: string,
    slug: string,
}

const app = createApp({
    props: {
        selectedMake: {type: String, default: ''},
        makes: {type: Object, required: true},
    },
    data() {
        return {
            filterMake: '',
        };
    },
    computed: {
        filterMakeOptions(): DropdownOptions {
            this.options = [];

            for (const key in this.makes) {
                if (this.makes.hasOwnProperty(key)) {
                    const element: Make = this.makes[key];

                    this.options.push({
                        value: element.slug,
                        text: element.make,
                    });
                }
            }

            return this.options;
        },
    },
    methods: {
        filterMakes() {
            if (!this.filterMake) {
                return;
            }

            window.location.href = '/car-reviews/make/' + this.filterMake;
        },
    },
    mounted() {
        if (this.selectedMake) {
            this.filterMake = this.selectedMake;
        }
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);

app.mount('#makes-form');
